app.directive('rentevergelijken', ['bezoeker', 'globals', '$http', '$window', '$timeout', function(bezoeker, globals, $http, $window, $timeout){
	return {
		restrict: 'EAC',
		scope: {
		  bedrag: '=?',
		  productvorm: '=?',
		  looptijd: '@?',
		},
		templateUrl: '/templates/rentevergelijken.html',
		link: function($scope, $element) {

            $scope.bezoeker = bezoeker;
            $scope.dkBedragMelding = false;
            $scope.plBedragMelding = false;

            $scope.looptijd = $scope.bezoeker.looptijd;

            $scope.kredietLoans = true;

            $scope.maandlastOptions = [{label : '€ '+($scope.bedrag * 0.02).toFixed(2).replace('.',','), value: 2},{label : '€ '+($scope.bedrag * 0.015).toFixed(2).replace('.',','), value: 1},{label: '€ '+($scope.bedrag * 0.01).toFixed(2).replace('.',','), value: 0}];
            $scope.maandlast = $scope.maandlastOptions[0];

            $scope.$watch('bedrag', function(){
                $scope.maandlastOptions = [{label : '€ '+($scope.bedrag * 0.02).toFixed(2).replace('.',','), value: 2},{label : '€ '+($scope.bedrag * 0.015).toFixed(2).replace('.',','), value: 1},{label: '€ '+($scope.bedrag * 0.01).toFixed(2).replace('.',','), value: 0}];
                $scope.maandlast = $scope.maandlastOptions[$scope.maandlast.value];
            }, true);

            $scope.Math = $window.Math;
            $scope.bankReviews = {};
            $scope.bankRisicoprofiel = {
                'defam' : true,
                'nationale-nederlanden' : true,
                'interbank' : false,
                'qander' : false,
                'bnp-paribas' : true,
                'lender-spender' : false,
            };
            $scope.bankMark = {
                'defam' : [
                    {id: 1, icon: 'check', text: 'Boetevrij extra aflossen'},
                    {id: 2, icon: 'check', text: 'Laagste vaste rente van Nederland'},
                    {id: 3, icon: 'check', text: '100% dochter ABN-AMRO'},
                    {id: 4, icon: 'times', text: 'Geen kwijtschelding bij overlijden'},
                    {id: 5, icon: 'check', text: 'Digitaal aanleveren en tekenen documenten via Mijn.Krediet.nl mogelijk'}
                ],
                'nationale-nederlanden' : [
                    {id: 1, icon: 'check', text: 'Boetevrij extra aflossen'},
                    {id: 2, icon: 'times', text: 'Geen kwijtschelding bij overlijden'},
                    {id: 3, icon: 'check', text: 'Digitaal aanleveren documenten via Mijn.Krediet.nl mogelijk'}
                ],
                'interbank' : [
                    {id: 1, icon: 'check', text: 'Boetevrij extra aflossen'},
                    {id: 2, icon: 'check', text: '100% dochter Crédit Agricole'},
                    {id: 3, icon: 'times', text: 'Geen kwijtschelding bij overlijden'},
                    {id: 4, icon: 'check', text: 'Digitaal aanleveren documenten via Mijn.Krediet.nl mogelijk'}
                ],
                'qander' : [
                    {id: 1, icon: 'check', text: 'Boetevrij extra aflossen'},
                    {id: 2, icon: 'times', text: 'Geen kwijtschelding bij overlijden'},
                    {id: 3, icon: 'check', text: 'Digitaal aanleveren documenten via Mijn.Krediet.nl mogelijk'}
                ],
                'bnp-paribas' : [
                    {id: 1, icon: 'check', text: 'Boetevrij extra aflossen'},
                    {id: 2, icon: 'check', text: 'Kwijtschelding bij overlijden'},
                    {id: 3, icon: 'check', text: 'Digitaal aanleveren en tekenen documenten via Mijn.Krediet.nl mogelijk'}
                ],
                'lender-spender' : [
                    {id: 1, icon: 'check', text: 'Boetevrij extra aflossen'},
                    {id: 2, icon: 'check', text: 'Meest innovatieve bank van Nederland'},
                    {id: 3, icon: 'times', text: 'Geen kwijtschelding bij overlijden'},
                    {id: 3, icon: 'check', text: 'Digitaal aanleveren documenten via eigen digitale omgeving'}
                ]
            };

            $scope.objectContainsKey = function(object, key) {
                if(typeof object !== 'undefined'){
                    return key in object;
                }
            };

            var getRentetarievenTimeout = null;

            $scope.$watch('bedrag', function(){
                if (getRentetarievenTimeout) $timeout.cancel(getRentetarievenTimeout);

                getRentetarievenTimeout =  $timeout(function(){
                        $scope.getRentetarieven();
                },  2000);

            });

            $scope.getRentetarieven = function(){
                $scope.dkBedragMelding = false;
                $scope.plBedragMelding = false;

                if($scope.bedrag < 2500 && $scope.productvorm == 'persoonlijke lening'){
                  $scope.bedrag = 2500;
                  $scope.plBedragMelding = true;
                }
                if($scope.bedrag < 10000 && $scope.productvorm == 'doorlopend krediet'){
                  $scope.dkBedragMelding = true;
                  $scope.bedrag = 10000;
                }

                if($scope.bedrag > globals.maximumAmount)
                {
                    $scope.bedrag = globals.maximumAmount;
                }

                if($scope.productvorm == 'doorlopend krediet'){
                    $scope.bezoeker.productvorm = 'Doorlopend krediet';
                }else if($scope.productvorm == 'persoonlijke lening'){
                    $scope.bezoeker.productvorm = 'Persoonlijke lening';
                }

                if($scope.maandlast['value'] ==  0){
                    $scope.bezoeker.maandlast = '0.01';
                }else if($scope.maandlast['value'] == 1){
                    $scope.bezoeker.maandlast = '0.015';
                }else if($scope.maandlast['value'] == 2){
                    $scope.bezoeker.maandlast = '0.02';
                }

                $scope.bezoeker.gewenstLeenbedrag = $scope.bedrag;
                $scope.bezoeker.looptijd = $scope.looptijd;

                $scope.bezoeker.store();

                $http.post('/rentetarieven/getInterestAllBanks/', {'bedrag' : $scope.bedrag, 'product' : $scope.productvorm, 'looptijd' : $scope.looptijd, 'maandlast' : $scope.maandlast.value, 'aanTeBieden' : $scope.kredietLoans}).

                success(function(data, status, headers, config) {
                    if( data.hasOwnProperty('defam premium') && data.hasOwnProperty('defam') ) {
                        delete data.defam;
                    }
                    $scope.rentetarieven = data;
                    rebuildFunctions();
                });
            };

            $scope.durationOptions = [
                {id:12,text:"12 maanden (1 jaar)"},
                {id:24,text:"24 maanden (2 jaar)"},
                {id:36,text:"36 maanden (3 jaar)"},
                {id:48,text:"48 maanden (4 jaar)"},
                {id:60,text:"60 maanden (5 jaar)"},
                {id:72,text:"72 maanden (6 jaar)"},
                {id:84,text:"84 maanden (7 jaar)"},
                {id:96,text:"96 maanden (8 jaar)"},
                {id:108,text:"108 maanden (9 jaar)"},
                {id:120,text:"120 maanden (10 jaar)"}
            ];

            $scope.banklogo = function(bankName){
            	var imgName = {
            		'ABN Amro' : 'abnamro',
            		'BNP' : 'bnp-paribas',
            		'defam' : 'defam',
            		'defam premium' : 'defam',
            		'Directa' : 'directa',
            		'Findio' : 'findio',
            		'Freo' : 'freo',
            		'ING' : 'ing',
            		'interbank' : 'interbank',
            		'MoneYou' : 'moneyou',
            		'Nationale Nederlanden' : 'nationale-nederlanden',
            		'Qander' : 'qander',
            		'Rabobank' : 'rabobank',
            		'Santander' : 'santander',
            		'SNS Bank' : 'snsbank',
                    'LS' : 'lender-spender'
            	};
                if(typeof imgName[bankName] !== 'undefined'){
                    return imgName[bankName];
                } else{
                    return false;
                }
            }

            function getBankReviews()
            {
                $http.get('/trustpilot/getAllReviews/').

                success(function(data, status, headers, config) {
                    $scope.bankReviews = data;
                });
            }

			/* Na het opnieuw inladen van de rentetarieven moet de styling op de selectbox opnieuw geinitieerd worden. */
			function rebuildSelect2()
			{
				$("select.js-select").select2({
					minimumResultsForSearch: -1,
					width: '100%',
					theme: 'pwc',
					dropdownAutoWidth: 'true'
				});
			}

            /* Zet de nieuwe hoogte van de sticky sidebar o.b.v. het aantal nieuwe rentetarieven */
            function rebuildStickySidebar() {
                $('.sticky-sidebar').theiaStickySidebar({
                    // Settings
                    additionalMarginTop: 96,
                    containerSelector: '.sticky-container'
                });
            }

            /*
                Wachten voordat de html elementen zijn toegevoegd op de pagina, daarna de functies op de html elementen toevoegen.
            */
            function rebuildFunctions() {
                $window.setTimeout(function() {
                    rebuildSelect2();
                    rebuildStickySidebar();
                }, 10 );
            }

            getBankReviews();
			rebuildFunctions();
            $scope.getRentetarieven();
        }
    };
}]);